import { useState, useEffect } from "react";
import BottomNav from "../components/BottomNav";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "../services/api";

const T = { night:"#0A1F3D", royal:"#1263B0", cyan:"#1CBCD3", gold:"#C9922A",
  white:"#fff", bg:"#F7F9FC", border:"#E2E8F0" };

export default function Notifications() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [notifs, setNotifs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/notifications")
      .then(r => setNotifs(r.data?.data || []))
      .catch(() => setNotifs([]))
      .finally(() => setLoading(false));
  }, []);

  const ICON = { MATCHING:"🎯", ACCOUNT:"✅", DECLARATION:"📋",
    RESTITUTION:"📦", TRANSACTION:"📜", DEFAULT:"🔔" };

  return (
    <div style={{ minHeight:"100vh", background:T.bg, fontFamily:"'DM Sans',sans-serif" }}>
      <div style={{ background:`linear-gradient(135deg,${T.night},${T.royal})`,
        padding:"20px 24px", display:"flex", alignItems:"center", gap:"16px" }}>
        <button onClick={() => nav(-1)}
          style={{ background:"transparent", border:"none", color:T.white,
            fontSize:"20px", cursor:"pointer" }}>←</button>
        <h1 style={{ color:T.white, fontSize:"18px", fontWeight:700, margin:0 }}>
          {t("notifications.title")}</h1>
      </div>

      <div style={{ maxWidth:"700px", margin:"0 auto", padding:"24px 24px 80px" }}>
        {loading ? (
          <div style={{ textAlign:"center", padding:"60px", color:"#64748B" }}>{t("common.loading")}</div>
        ) : notifs.length === 0 ? (
          <div style={{ textAlign:"center", padding:"60px" }}>
            <div style={{ fontSize:"48px", marginBottom:"16px" }}>🔔</div>
            <p style={{ color:"#64748B" }}>{t("notifications.empty")}</p>
          </div>
        ) : (
          <div style={{ display:"flex", flexDirection:"column", gap:"12px" }}>
            {notifs.map((n, i) => (
              <div key={i} style={{ background:T.white, borderRadius:"14px",
                padding:"16px 20px", border:`1px solid ${T.border}`,
                display:"flex", gap:"14px", alignItems:"flex-start" }}>
                <div style={{ width:"40px", height:"40px", borderRadius:"10px",
                  background:"#F1F5F9", display:"flex", alignItems:"center",
                  justifyContent:"center", fontSize:"18px", flexShrink:0 }}>
                  {ICON[n.type] || ICON.DEFAULT}
                </div>
                <div style={{ flex:1 }}>
                  <div style={{ fontWeight:600, fontSize:"14px", color:T.night,
                    marginBottom:"4px" }}>{n.title}</div>
                  <div style={{ fontSize:"13px", color:"#64748B", marginBottom:"6px" }}>{n.message}</div>
                  <div style={{ fontSize:"11px", color:"#94A3B8" }}>{n.timeAgo || n.time_ago}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <BottomNav />
    </div>
  );
}
